<template>
    <div>
        <div
            class="EventWidget__item"
            :data-index="index"
            v-for="(event, index) in events"
            :key="event.id"
            v-html="event.widget"
            @click="redirect(`/akce/${event.id}`)"
        ></div>
        <div class="JobIndex__empty" v-if="! events.length">
            <div class="text-center text-gray-light py-5" v-if="loading">
                <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
            </div>
            <slot v-else>v současné době nenabízíme žádné akce</slot>
        </div>
    </div>
</template>

<script>
export default {

    props: [
        'source',
    ],

    data() {
        return {
            events: [],
            loading: true
        }
    },

    methods: {

        loadDataFromSource() {
            axios.get(url(this.source))
                .then(response => {
                    this.events = response.data.data;
                    this.loading = false;
                })
                .catch(errors => {
                });
        },

        redirect(uri) {
            window.location.assign(url(uri));
        }
    },

    mounted() {
        this.loadDataFromSource();
    }
}
</script>
